/**
 * Performs Resize observation on HTML elements.
 */
class ResizeObserverWrapper {
  /**
   * ResizeObserverWrapper constructor.
   */
  constructor() {
    // Initialize an instance of resize observer only if there is none
    if (!ResizeObserverWrapper.instance) {
      this.initialize();
      ResizeObserverWrapper.instance = this;
    }

    return ResizeObserverWrapper.instance;
  }

  /**
   * Initialize the Resize Observer wrapper
   */
  initialize() {
    this.weakMap = new WeakMap();
    this.resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const callback = this.weakMap.get(entry.target);
        callback();
      });
    });
  }

  /**
   * Add a new element entry to the resize observer
   * @param {Element}   element   The element to observe
   * @param {Function}  callback  What to do when a resize occurs
   */
  add(element, callback) {
    this.weakMap.set(element, callback);
    this.resizeObserver.observe(element);
  }

  /**
   * Remove an entry from the resize observer
   * @param {Element}   element   The element to unobserve
   */
  remove(element) {
    this.weakMap.delete(element);
    this.resizeObserver.unobserve(element);
  }
}

const resizeObserverWrapper = new ResizeObserverWrapper();
export default resizeObserverWrapper;
